// Constant: Options > Colors
const COLORS = ['green', 'yellow', 'pink', 'purple', 'blue']

// Constant: Options > Intents
const INTENTS = ['information', 'danger', 'success', 'warning']

// Constant: Options > Levels
const LEVELS = ['novice', 'intermediate', 'advanced']

// Constant: Options > Media types
const MEDIA_TYPES = ['image', 'video', 'document']

// Constant: Options > Themes
const THEMES = ['light', 'dark']

// Constant: Options > Text inputs
const TEXT_INPUTS = ['text', 'number', 'email', 'password']

// Constant: Options > Input types
const INPUT_TYPES = [...TEXT_INPUTS, 'submit']

// Export
export {
  COLORS,
  INPUT_TYPES,
  INTENTS,
  LEVELS,
  MEDIA_TYPES,
  THEMES,
  TEXT_INPUTS
}
